import { PhoneOutlined } from '@mui/icons-material';
import { Chip } from '@mui/material';
import React from 'react';
export const TimelineListItemInfoChip = (props) => {
    const { label, value, backgroundColor, textColor, showPhoneIcon, crossOut } = props;
    return (React.createElement(Chip, { style: {
            backgroundColor: backgroundColor,
            color: textColor,
            borderRadius: '4px',
            fontWeight: '500',
            marginRight: '10px',
            height: '25px',
            textTransform: 'uppercase'
        }, label: React.createElement("span", { style: { display: 'flex', alignItems: 'center', gap: '4px', textTransform: 'uppercase' } },
            label,
            label !== '' && ':',
            " ",
            React.createElement("span", { style: { display: 'flex', fontWeight: 700, textTransform: 'uppercase', textDecoration: crossOut ? 'line-through' : '' } }, value),
            " ",
            showPhoneIcon && React.createElement(PhoneOutlined, { style: { fontSize: 'medium' } })) }));
};
